import { selectNode } from './helpers';
import { addToCart } from './cart';
import {checkShopOpenDate} from './shared'

// show errors on some occasions
function error_handler(errorsWrapper, submit, submitAndCheckout) {
  const errors = {
    partners: selectNode('partners', errorsWrapper),
    sameDay: selectNode('same_day_delivery', errorsWrapper),
    allFields: selectNode('all_fields', errorsWrapper),
    sameDayTime: selectNode('same_day_delivery_time', errorsWrapper),
    saturday: selectNode('saturday_delivery', errorsWrapper),
  };
  const errorsKeys = Object.keys(errors);

  const hideErrors = () =>
    errorsKeys.map(el => errors[el].classList.remove('active'));

  return function(errorCode) {
    hideErrors();

    if (errorCode && errors.hasOwnProperty(errorCode)) {
      errors[errorCode].classList.add('active');
    } else {
      submit.classList.add('valid');
      submitAndCheckout.classList.add('valid');
    }
  };
}

// FIX for the datepicker placed in modal with fixed position
function jQueryUiDatepickerPatch() {
  const checkOffset = jQuery.datepicker._checkOffset;

  jQuery.extend(jQuery.datepicker, {
    _checkOffset: function(inst, offset, isFixed) {
      if (!isFixed) {
        return checkOffset.apply(this, arguments);
      }

      let isRTL = this._get(inst, 'isRTL');
      let obj = inst.input[0];

      // copied from Datepicker._findPos (node_modules/jquery-ui/datepicker.js)
      while (
        obj &&
        (obj.type === 'hidden' ||
          obj.nodeType !== 1 ||
          jQuery.expr.filters.hidden(obj))
      ) {
        obj = obj[isRTL ? 'previousSibling' : 'nextSibling'];
      }

      let rect = obj.getBoundingClientRect();

      return {
        top: rect.top,
        left: rect.left
      };
    }
  });
}

// before add to cart modal functionality
export default function modalFunctionality({ zones }, submitedIds) {
  const modal = selectNode('delivery-modal');
  const errorsNode = selectNode('delivery-modal__errors', modal);
  const zipcodeInput = selectNode('modal-zipcode', modal);
  const dateInput = selectNode('modal-date', modal);
  const submit = selectNode('delivery-modal__submit', modal);
  const submitAndCheckout = selectNode('delivery-modal__submit-checkout', modal);
  const dropdown = selectNode('delivery-modal__dropdown', modal);
  const dropdownResult = selectNode(
    'delivery-modal__dropdown-result',
    dropdown
  );
  const closeModalBtn = selectNode('delivery-modal__close', modal);
  const submitError = error_handler(errorsNode, submit, submitAndCheckout);

  // constant for zone_name that will allow same day delivery
  const CITY_ZONE_NAME = window.sharedResources.sameDayZoneName || '';

  // reduce zipcode object to array
  const zipcodes = Object.keys(zones).reduce((res, el) => {
    const value = zones[el];
    return [
      ...res,
      ...value.zone_locations.map(zone => ({ ...zone, name: value.zone_name }))
    ];
  }, []);

  const windowScrollOffset = window.scrollY;

  modal.classList.add('opened');
  document.body.classList.add('modal-opened');

  const closeModal = e => {
    if (e) e.preventDefault();

    modal.classList.remove('opened');
    document.body.classList.remove('modal-opened');
    window.scroll(0, windowScrollOffset);
  };

  const hideDropdown = () => dropdown.classList.remove('visible');

  // create list of zipcodes for dropdown
  const createListItems = zipcodes => {
    const fragment = document.createDocumentFragment();
    zipcodes.map(({ code }) => {
      const li = document.createElement('li');
      const submitCode = () => {
        zipcodeInput.value = code;
        hideDropdown();
        submitError();
      };

      li.innerText = code;
      li.dataset.code = code;
      li.addEventListener('click', submitCode);
      fragment.appendChild(li);
    });
    return fragment;
  };

  // check if zipcode is in the list and create dropdown
  const zipcodeChecker = e => {
      e.target.value = e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1').replace(/^0[^.]/, '0');
    if (!e.target.value.length) {
      hideDropdown();
      dropdownResult.innerHTML = '';
    } else {
      dropdown.classList.add('visible');

      const similarCodes = zipcodes.filter(el =>
        el.code.toString(10).includes(e.target.value)
      );

      if (similarCodes.length) {
        dropdownResult.innerHTML = '';
        dropdownResult.appendChild(createListItems(similarCodes));

        if (similarCodes[0].code === e.target.value) {
          hideDropdown();
          submitError();
          return true;
        }
      } else {
        hideDropdown();
        submitError('partners');
        return false;
      }
    }
  };

  // checks if zipcode and date fields are not empty
  const emptyFieldsChecker = () => {
    const zipcode = selectNode('modal-zipcode', modal);
    const date = selectNode('modal-date', modal);

    if (zipcode.value && date.value) {
      return true;
    } else {
      submitError('allFields');
      return false;
    }
  };

    const isValidZipcode = zipcodeValue =>
        zipcodes.some(
            ({code, name}) => code == zipcodeValue && name === CITY_ZONE_NAME
        )

  // mostly) checks date for possibility to deliver the same day
  const dateChecker = () => {
    const zipcode = selectNode('modal-zipcode', modal);
    const dateNode = selectNode('modal-date', modal);
    const currentDate = new Date();
    const currentDateDay = currentDate.getDate();
    const currentDateMonth = currentDate.getMonth();
    const pickedDate = new Date(dateNode.value);
    const pickedDateDay = pickedDate.getDate();
    const pickedDateMonth = pickedDate.getMonth();

    if (
      pickedDateDay === currentDateDay &&
      pickedDateMonth === currentDateMonth
    ) {
      if (currentDate.getHours() >= 14) {
        submitError('sameDayTime');
      } else if (!isValidZipcode(zipcode.value)) {
        submitError('sameDay');
      } else {
        return true;
      }

      return false;
    } else if (!isValidZipcode(zipcode.value) && pickedDate.getDay() === 6) {
      submitError('saturday');
      return false;
    }

    submitError();
    return true;
  };

  // send data to update woocommerce session
  const updateWcSession = e => {
    jQuery.ajax({
      url: window.sharedResources.ajaxurl,
      type: 'POST',
      data: {
        action: 'update-session',
        payload: {
          zipcode: zipcodeInput.value,
          date: dateInput.value
        }
      }
    });
  };

  // submit modal data
  const submitModal = () => {
    if (
      emptyFieldsChecker() &&
      dateChecker() &&
      zipcodeChecker({ target: zipcodeInput })
    ) {
      addToCart(submitedIds);
      document.addEventListener('product-submited', updateWcSession);
      closeModal();
    }
  };

  // init jQuery-UI datepicker with dates check

  const formatDate = date => {
    const pad = num => (num < 10 ? `0${num}` : num);

    return (
      date.getFullYear() +
      '-' +
      pad(date.getMonth() + 1) +
      '-' +
      pad(date.getDate())
    );
  };

  const $datepickerField = jQuery('#delivery-modal-date');

  // set regional standard
    jQuery.datepicker.setDefaults(jQuery.datepicker.regional['sv']);

    jQueryUiDatepickerPatch()

    $datepickerField.datepicker({
        beforeShowDay(date) {
            return [checkShopOpenDate(date, isValidZipcode(selectNode('modal-zipcode', modal).value)), '']
        },
        minDate: 0,
    })

  jQuery('.delivery-modal__label.date-input-field').on('click', function() {
    $datepickerField.datepicker('show');
  });

    zipcodeInput.addEventListener('input', zipcodeChecker);
  submit.addEventListener('click', submitModal);

  const submitAndGo = (e) => {
      submitModal()
      document.addEventListener('product-submited', () => {
          setTimeout(() => window.location.href = e.target.dataset.carturl, 500)
      });
  };
  submitAndCheckout.addEventListener('click', submitAndGo)

  closeModalBtn.addEventListener('click', closeModal);
  modal.addEventListener('click', e => {
    if (e.target === modal) {
      closeModal();
    }
  });
}
